import { ReactNode } from "react";

import classes from "./SplitPageLayout.module.css";

type SplitPageLayoutProps = {
  left: ReactNode;
  backgroundImagePath: string;
};
export const SplitPageLayout = ({
  left,
  backgroundImagePath,
}: SplitPageLayoutProps) => {
  return (
    <div className={classes.container}>
      <div className={classes.left}>{left}</div>
      <div
        style={{ backgroundImage: `url('${backgroundImagePath}')` }}
        className={classes.right}
      ></div>
    </div>
  );
};
